import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  HTMLAttributes,
  useRef,
} from 'react';

interface MapContextData {
  showMarkerInfoWindow: (item: GuideItem) => void;
  infoWindowPositon?: google.maps.LatLngLiteral;
  isOpen: boolean;
  infoWindowData: GuideItem[];
  mapRef: React.MutableRefObject<HTMLDivElement | null>;
  setInfoWindowPosition: React.Dispatch<
    React.SetStateAction<google.maps.LatLngLiteral | undefined>
  >;
  setInfoWindowData: React.Dispatch<React.SetStateAction<GuideItem[]>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MapContext = createContext<MapContextData>({} as MapContextData);

export const MapProvider = ({ children }: { children: ReactNode }) => {
  const mapRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [infoWindowPositon, setInfoWindowPosition] =
    useState<google.maps.LatLngLiteral>();
  const [infoWindowData, setInfoWindowData] = useState<GuideItem[]>([]);

  function showMarkerInfoWindow(item: GuideItem) {
    document.getElementById(`${item.id}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    });
    setInfoWindowData(Array(item));
    setInfoWindowPosition({
      lat: item?.surrounding?.location?.latitude || 37.7630382,
      lng: item?.surrounding?.location?.longitude || 13.486066,
    });
    setIsOpen(true);

    const body = document.body;

    if (mapRef.current) {
      window.scrollTo({
        top:
          mapRef.current.getBoundingClientRect().top -
          body.getBoundingClientRect().top -
          120,
      });
    }
  }

  return (
    <MapContext.Provider
      value={{
        showMarkerInfoWindow,
        infoWindowPositon,
        isOpen,
        mapRef,
        infoWindowData,
        setInfoWindowPosition,
        setInfoWindowData,
        setIsOpen,
      }}>
      {children}
    </MapContext.Provider>
  );
};

export function useMap(): MapContextData {
  const context = useContext(MapContext);

  if (!context) {
    throw new Error('UseMap must be used within an UseMapProvider');
  }

  return context;
}
